import { Navigate, Route, Routes } from "react-router-dom";

import { Alert } from "../../components/ui";
import { LoginPage } from "../../features/auth/pages/LoginPage";
import { RegisterPage } from "../../features/auth/pages/RegisterPage";
import { ForgotPasswordPage } from "../../features/auth/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "../../features/auth/pages/ResetPasswordPage";
import { DashboardPage } from "../../features/dashboard/pages/DashboardPage";
import { DataExportPage } from "../../features/data-export/pages/DataExportPage";
import { MemberDetailPage } from "../../features/members/pages/MemberDetailPage";
import { MemberListPage } from "../../features/members/pages/MemberListPage";
import { MaterialDetailPage } from "../../features/materials/pages/MaterialDetailPage";
import { MaterialListPage } from "../../features/materials/pages/MaterialListPage";
import { MaterialManagePage } from "../../features/materials/pages/MaterialManagePage";
import { QuestionnaireDraftEditorPage } from "../../features/questionnaire/pages/QuestionnaireDraftEditorPage";
import { QuestionnaireManagePage } from "../../features/questionnaire/pages/QuestionnaireManagePage";
import { QuestionnairePreviewPage } from "../../features/questionnaire/pages/QuestionnairePreviewPage";
import { QuestionnaireResponsePage } from "../../features/questionnaire/pages/QuestionnaireResponsePage";
import { QuestionnaireResultsPage } from "../../features/questionnaire/pages/QuestionnaireResultsPage";
import { QuestionnaireSubmissionDetailPage } from "../../features/questionnaire/pages/QuestionnaireSubmissionDetailPage";
import { UiGalleryPage } from "../../features/ui-gallery/UiGalleryPage";
import { VoiceAssistantPage } from "../../features/voice/pages/VoiceAssistantPage";
import { VoiceConversationPage } from "../../features/voice/pages/VoiceConversationPage";
import { AppShell } from "../../layouts/AppShell";
import { SessionBoundary } from "../session/SessionBoundary";
import { useSession } from "../session/SessionProvider";

function Dashboard() {
  const { member } = useSession();
  return <DashboardPage role={member?.role ?? "STUDENT"} />;
}
function Forbidden() {
  return (
    <AppShell title="無權限" breadcrumb={["無權限"]}>
      <Alert variant="danger">你沒有權限查看此頁面。</Alert>
    </AppShell>
  );
}
export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route
        path="/"
        element={
          <SessionBoundary>
            <Dashboard />
          </SessionBoundary>
        }
      />
      <Route
        path="/voice"
        element={
          <SessionBoundary>
            <VoiceAssistantPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/voice/conversation"
        element={
          <SessionBoundary>
            <VoiceConversationPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/materials"
        element={
          <SessionBoundary>
            <MaterialListPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/materials/:materialId"
        element={
          <SessionBoundary>
            <MaterialDetailPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/data-export"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <DataExportPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/materials"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <MaterialManagePage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/questionnaire"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <QuestionnaireManagePage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/questionnaire/draft"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <QuestionnaireDraftEditorPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/questionnaire/preview"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <QuestionnairePreviewPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/questionnaire/results"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <QuestionnaireResultsPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/questionnaire/submissions/:submissionId"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <QuestionnaireSubmissionDetailPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/questionnaire"
        element={
          <SessionBoundary roles={["STUDENT"]}>
            <QuestionnaireResponsePage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/members"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <MemberListPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/admin/members/:memberId"
        element={
          <SessionBoundary roles={["EDUCATOR_ADMIN"]}>
            <MemberDetailPage />
          </SessionBoundary>
        }
      />
      <Route
        path="/forbidden"
        element={
          <SessionBoundary>
            <Forbidden />
          </SessionBoundary>
        }
      />
      <Route path="/ui-gallery" element={<UiGalleryPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
